import { BasePhoneEmailValidation } from './base-phone-email';

const RecontactFormValidation = BasePhoneEmailValidation.shape({});

export default RecontactFormValidation;
